import { css } from '@linaria/core'

// Fade-in when toggled, fade out when not
export const showCss = css`
  opacity: 0;
  transition: opacity 0.3s;

  [icon-toggle] & {
    opacity: 1;
  }
`

// Fade-out when toggled, fade in when not
export const hideCss = css`
  opacity: 1;
  transition: opacity 0.3s;

  [icon-toggle] & {
    opacity: 0;
  }
`

// Fill-in from center when toggled. Fade out when not
export const fillCss = css`
  opacity: 0;
  clip-path: circle(1px at 50% 50%);
  transition:
    opacity 0.3s ease 0.1s,
    clip-path 0.5s;

  [icon-toggle] & {
    clip-path: circle(15px at 50% 50%);
    transition:
      opacity 0.2s,
      clip-path 0.5s;
    opacity: 1;
  }
`

export const wipeOnCss = css`
  clip-path: circle(0px at 0% 100%);
  transition: clip-path 0.5s;

  [icon-toggle] & {
    clip-path: circle(30px at 0% 100%);
  }
`

export const wipeOffCss = css`
  clip-path: circle(30px at 150% 0%);
  transition: clip-path 0.5s;

  [icon-toggle] & {
    clip-path: circle(0px at 150% 0%);
  }
`

// Temporarily scale me when toggled
export const bumpCss = css`
  transform-origin: center;
  @keyframes bump {
    from {
      transform: scale(1);
    }
    50% {
      transform: scale(1.15);
    }
    to {
      transform: scale(1);
    }
  }
  [icon-toggle] & {
    animation: 0.3s bump 0.2s;
  }
`

// Flip stuff horizontally when in RTL
export const rtlFlipCss = css`
  transform-origin: center;
  [dir='rtl'] & {
    transform: scaleX(-1);
  }
`
